import React, { useState } from "react";
import { Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";

export default props => {
    const [open, setOpen] = useState(false);
    const [name, setName] = useState("");

    const handleClose = async () => {
        setOpen(false);
        setName("");
    };

    return (
        <div>
            <Button onClick={() => setOpen(true)} variant="contained" size="small">
                Skriv ny problematik
            </Button>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" maxWidth="lg">
                <DialogTitle id="form-dialog-title">Nyt Felt</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="topic"
                        label="Titel"
                        type="text"
                        fullWidth
                        value={name}
                        onChange={event => {
                            setName(event.target.value);
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Luk
                    </Button>
                    <Button
                        onClick={() => {
                            props.onChange(name);
                            handleClose();
                        }}
                        color="primary">
                        Opret
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
